var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.49734C0 3.79763 3.79763 0 8.49734 0C13.1971 0 17 3.79763 17 8.49734C17 13.1971 13.1971 17 8.49734 17C3.79764 17 0 13.1971 0 8.49734ZM8.47211 3.75537C9.69003 3.75537 10.9092 4.22094 11.8357 5.1457C12.5714 5.87997 13.0167 6.79831 13.169 7.75373L13.3761 7.49346C13.5521 7.27331 13.8732 7.23763 14.0932 7.41378C14.3137 7.58932 14.35 7.91053 14.1742 8.13086L13.0694 9.50658C12.8653 9.75874 12.4807 9.75874 12.2766 9.50658L11.1731 8.13086C10.9969 7.91088 11.0326 7.58973 11.2528 7.41378C11.4366 7.26762 11.7374 7.23201 11.9712 7.49346L12.1159 7.67406C11.9661 7.01096 11.6314 6.38117 11.112 5.86278C9.64902 4.40261 7.29521 4.40261 5.83221 5.86278C4.36922 7.32294 4.36922 9.6771 5.83221 11.1373C7.29521 12.5974 9.64902 12.5974 11.112 11.1373C11.2653 10.9843 11.4029 10.8215 11.5237 10.6512C11.6867 10.4202 12.0067 10.366 12.2368 10.5304C12.4645 10.6932 12.5184 11.0091 12.3576 11.2382C12.2037 11.4552 12.0299 11.6619 11.8357 11.8557C9.98263 13.7052 6.96292 13.7052 5.10983 11.8557C3.25672 10.0062 3.25672 6.99522 5.10983 5.1457C6.03638 4.22094 7.2542 3.75537 8.47211 3.75537Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.52f4f05595d814d3af9b6746d64c40b4.svg";
export { ForwardRef as ReactComponent };